var weekStrMap = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

function weekDayStr(index) {
    return weekStrMap[index - 1];
}

function TimeInterval(timeInSeconds) {
    this.time = timeInSeconds;

    this.days = function () {
        return parseInt(this.time / (3600 * 24));
    };

    this.hours = function () {
        return parseInt((this.time % (3600 * 24)) / 3600);
    };

    this.minutes = function () {
        return parseInt((this.time % 3600) / 60);
    };

    this.seconds = function () {
        return (this.time % 60);
    };
}

function currentTimeInSeconds() {
    return parseInt(new Date().getTime() / 1000);
}

function timeIntervalStr(timeIntervalInSeconds) {
    let interval = new TimeInterval(timeIntervalInSeconds);

    return (interval.days() ? (interval.days() + "天") : "") + (interval.hours() ? (interval.hours() + "小时") : "") +
        (interval.minutes() ? (interval.minutes() + "分") : "") + (interval.seconds() ? (interval.seconds() + "秒") : "");
}

/**
 * date format
 */
Date.prototype.format = function (fmt) {
    let o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "H+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    };

    if(/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (let k in o) {
        if(new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }

    return fmt;
};

module.exports = {
    weekdayFn: weekDayStr,
    timeIntervalStr: timeIntervalStr,
    currentTimeInSeconds: currentTimeInSeconds,
};



//////////////////
// WEBPACK FOOTER
// ./static/js/timeutil.js
// module id = Wre1
// module chunks = 1